import { render, staticRenderFns } from "./AdminWorkplaceGroups.vue?vue&type=template&id=0cf9048b&"
import script from "./AdminWorkplaceGroups.vue?vue&type=script&lang=js&"
export * from "./AdminWorkplaceGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports